import { ContentId } from 'src/utils/constants/contentId';
import { EventMetricsTimestamp } from 'src/WebApiController';

import { OnSaleEventMetricsName } from './OnSaleEvent.types';

export const ON_SALE_EVENT_METRICS_DIMENSION_TO_CID = {
  [EventMetricsTimestamp.LastHour]: ContentId.Last1Hour,
  [EventMetricsTimestamp.LastDay]: ContentId.Last24Hours,
  [EventMetricsTimestamp.Last3Days]: ContentId.Last3Days,
  [EventMetricsTimestamp.LastWeek]: ContentId.LastWeek,
};

export const ON_SALE_EVENT_METRICS_TO_CID = {
  [OnSaleEventMetricsName.Clicks]: ContentId.Clicks,
  [OnSaleEventMetricsName.Transactions]: ContentId.Transactions,
  [OnSaleEventMetricsName.ConversionRate]: ContentId.BuyerConversionRate,
};
